import { useEffect, useState } from "react";
import { vpAxios, money } from "../api";
import { toast } from "sonner";
import { MapPin, User, RefreshCw, History } from "lucide-react";

export default function EntregasPage() {
  const [tab, setTab] = useState("prontas"); // prontas | rota | finalizadas
  const [pedidos, setPedidos] = useState([]);
  const [entregadores, setEntregadores] = useState([]);

  const load = async () => {
    try {
      let rp;
      if (tab === "prontas") {
        rp = await vpAxios.get("/vaipede/entregas/prontas");
      } else {
        rp = await vpAxios.get(`/vaipede/entregas/historico?status=${tab === "rota" ? "rota" : "finalizadas"}`);
      }
      const re = await vpAxios.get("/vaipede/entregadores");
      setPedidos(rp.data); setEntregadores(re.data);
    } catch {}
  };
  useEffect(() => {
    load();
    const iv = setInterval(load, 12000);
    return () => clearInterval(iv);
    // eslint-disable-next-line
  }, [tab]);

  const reatribuir = async (pid, eid) => {
    try {
      await vpAxios.patch(`/vaipede/entregas/${pid}/reatribuir`, { entregador_id: eid });
      toast.success(eid ? "Entregador atualizado" : "Entregador removido — pedido voltou para 'pronto'");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };

  const TABS = [
    { k: "prontas", l: "Prontas" },
    { k: "rota", l: "Em rota" },
    { k: "finalizadas", l: "Finalizadas" },
  ];

  return (
    <div data-testid="vaipede-entregas">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 className="text-2xl font-black">Entregas</h1>
          <p className="text-sm text-neutral-500">Acompanhe e reatribua entregas</p>
        </div>
        <button onClick={load} className="p-2.5 rounded-xl bg-white border border-neutral-200"><RefreshCw className="w-4 h-4"/></button>
      </div>

      <div className="flex gap-2 mb-4">
        {TABS.map(t => (
          <button key={t.k} onClick={() => setTab(t.k)} className={`px-4 py-2 rounded-full text-sm font-bold ${tab === t.k ? "bg-[#EA1D2C] text-white" : "bg-white border border-neutral-200 text-neutral-700"}`} data-testid={`vaipede-entregas-tab-${t.k}`}>
            {t.k === "finalizadas" && <History className="w-3 h-3 inline mr-1"/>} {t.l}
          </button>
        ))}
      </div>

      {pedidos.length === 0 && (
        <div className="bg-white rounded-2xl border border-neutral-200 p-10 text-center">
          <p className="text-neutral-500">Nenhum pedido nesta aba.</p>
        </div>
      )}

      <div className="grid md:grid-cols-2 gap-3">
        {pedidos.map(p => (
          <div key={p.id} className={`bg-white rounded-2xl border p-4 ${p.status === "saiu_entrega" ? "border-blue-300" : (p.status === "entregue" ? "border-emerald-200 opacity-90" : "border-emerald-300")}`}>
            <div className="flex items-center justify-between mb-2">
              <div className="font-black text-lg">#{p.numero}</div>
              <span className={`text-xs px-2 py-1 rounded-full font-bold ${
                p.status === "saiu_entrega" ? "bg-blue-100 text-blue-700" :
                p.status === "entregue" ? "bg-emerald-100 text-emerald-700" :
                "bg-amber-100 text-amber-700"
              }`}>
                {p.status === "saiu_entrega" ? "🛵 A caminho" : p.status === "entregue" ? "✅ Entregue" : "🍔 Pronto"}
              </span>
            </div>
            <div className="text-sm mb-2">
              <b>{p.cliente_nome || "Cliente"}</b>{p.cliente_whatsapp ? ` · ${p.cliente_whatsapp}` : ""}
            </div>
            {p.endereco && <div className="text-xs text-neutral-600 mb-1">📍 {p.endereco}</div>}
            {p.referencia && <div className="text-xs text-neutral-600 mb-1">🧭 <b>Ref:</b> {p.referencia}</div>}
            {(p.latitude && p.longitude) && (
              <a href={`https://www.google.com/maps?q=${p.latitude},${p.longitude}`} target="_blank" rel="noreferrer" className="text-xs text-emerald-700 inline-flex items-center gap-1 mb-2">
                <MapPin className="w-3 h-3"/> Ver no mapa
              </a>
            )}
            <div className="flex items-center justify-between mb-3 text-base"><b>Total</b><b className="text-[#EA1D2C]">{money(p.total)}</b></div>
            {tab !== "finalizadas" ? (
              <div className="flex items-center gap-2 bg-neutral-50 rounded-xl px-3 py-2">
                <User className="w-4 h-4 text-neutral-500"/>
                <select value={p.entregador_id || ""} onChange={e => reatribuir(p.id, e.target.value)} className="flex-1 bg-transparent text-sm outline-none" data-testid={`vaipede-entrega-reatr-${p.id}`}>
                  <option value="">— Sem entregador (liberar) —</option>
                  {entregadores.filter(e => e.ativo).map(e => (
                    <option key={e.id} value={e.id}>{e.nome}</option>
                  ))}
                </select>
              </div>
            ) : (
              <div className="text-xs text-neutral-500">
                🛵 {p.entregador_nome || "—"} · {p.entregue_em ? new Date(p.entregue_em).toLocaleString("pt-BR") : ""}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
